var $name="utmKeys",$path="configs/utmKeys.js",$this={$name,$path,};module.exports = {
  utmSource: 'utm_source',
  utmTactic: 'utm_tactic',
  utmTerm: 'utm_term',
  utmCampaign: 'utm_campaign',
};
